<template>
  <div class="pt-2 px-2">
    <div v-for="speaking in mapSpeaking" :key="speaking.id">
      <div v-if="speaking.textCorrect && (speaking.id === 1 || isShowFull)" v-html="showText(speaking, 'correct')"></div>
      <span v-if="!isShowFull && countTextShow > 1 && speaking.id === 1"><span class="text-info" @click="showAll()">Xem thêm</span></span>
      <div v-if="speaking.textIncorrect && isShowFull" v-html="showText(speaking, 'incorrect')"></div>
    </div>
    <span v-if="isShowFull"><span class="text-info" @click="hideAll()">Ẩn bớt</span></span>
    <p class="text-center" v-if="!countTextShow">-</p>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      mapSpeaking: [
        {
          id: 1,
          textCorrect: 'Con nhớ và sử dụng linh hoạt các từ: {text}.',
          colorCorrect: '#00CC60',
          textIncorrect: 'Con hãy dành thêm thời gian ôn tập lại các từ: {text} nhé!',
          colorIncorrect: '#FF6500',
          fontWeight: 'normal',
        },
        {
          id: 2,
          textCorrect: 'Con ghi nhớ và vận dụng được cấu trúc câu: {text}.',
          colorCorrect: '#00CC60',
          textIncorrect: 'Con cần ôn luyện thêm để thành thạo cấu trúc câu: {text} nhé!',
          colorIncorrect: '#FF6500',
          fontWeight: 'normal',
        },
        {
          id: 3,
          textCorrect: 'Con phát âm tốt, dễ nghe và dễ hiểu các từ: {text}.',
          colorCorrect: '#00CC60',
          textIncorrect: 'Con cần rèn luyện thêm các từ: {text} để phát âm chính xác và rõ ràng hơn con nhé!',
          colorIncorrect: '#FF6500',
          fontWeight: 'normal',
        },
        {
          id: 4,
          textCorrect: 'Con trả lời các câu hỏi của cô một cách {text}.',
          colorCorrect: '#000',
          fontWeight: 'bold',
        },
      ],
      vocab: {}, // id: 1
      grammar: {}, // id: 2
      pro: {}, // id: 3
      fluency: {}, // id: 4
      countTextShow: 0,
      isShowFull: false,
    };
  },
  created() {
    if (this.item.speaking_score && this.item.speaking_score.length) {
      this.vocab = this.item.speaking_score.find((item) => item.id === 1);
      this.grammar = this.item.speaking_score.find((item) => item.id === 2);
      this.pro = this.item.speaking_score.find((item) => item.id === 3);
      this.fluency = this.item.speaking_score.find((item) => item.id === 4);
    }

    if (this.item.speaking_score && this.item.speaking_score.length) {
      this.item.speaking_score.forEach((item) => {
        if ((item.correct && item.correct.length) || (item.incorrect && item.incorrect.length)) {
          this.countTextShow += 1;
        }
      });
    }
  },
  methods: {
    showText(textItem, type) {
      if (this.item.speaking_score && this.item.speaking_score.length) {
        const textShow = this.item.speaking_score.find((item) => item.id === textItem.id);
        if (type === 'correct' && textShow.correct && textShow.correct.length) {
          const tagStr = `<span style="color:${textItem.colorCorrect};font-weight: ${textItem.fontWeight}">${textShow.correct.join('; ')}</span>`;
          return textItem.textCorrect.replace('{text}', tagStr);
        }

        if (textShow.incorrect && textShow.incorrect.length) {
          const tagStr = `<span style="color:${textItem.colorIncorrect};font-weight: ${textItem.fontWeight}">${textShow.incorrect.join('; ')}</span>`;
          return textItem.textIncorrect.replace('{text}', tagStr);
        }
      }

      return null;
    },
    showAll() {
      this.isShowFull = true;
    },

    hideAll() {
      this.isShowFull = false;
    },
  },
};
</script>
<style lang="scss" scoped>
  .text-info {
    color: #1187CA;
  }
</style>
<style lang="scss">
</style>
